class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
/** variant select box change event **/
  $(document).on('change','.cart_compatible_accessories_select' ,function(e){
    e.preventDefault();
    var vTitle= $('option:selected',this).text();
      var vID= $('option:selected',this).val();
   //alert(vID);
    $(this).parents('.product-item.cart').find('form input[name="id"]').val(vID);
    var Vimg=$.trim($('option:selected',this).attr('data-image'));
    var VPrice=$.trim($('option:selected',this).attr('data-price'));
      var VCPrice=$.trim($('option:selected',this).attr('data-compareP'));
    var inventory_quantity=$.trim($('option:selected',this).attr('data-inventory_quantity'));
    inventory_quantity=parseInt(inventory_quantity);
    var inventory_policy=$.trim($('option:selected',this).attr('data-inventory_policy'));
    $(this).parents('.product-item').find('.product-variant-id').val(vID);
    if(Vimg !=''){
    $(this).parents('.product-item').find('.cart_compatible_accessories_url .items-content-inner img').attr('src',Vimg);
    }
     if(VPrice !=''){
    $(this).parents('.product-item').find('.cart_compatible_accessories_url .pice-text').html(VPrice);
    }
     if(VCPrice !='' && VCPrice !=VPrice){
    $(this).parents('.product-item').find('.cart_compatible_accessories_url .item-price .tw-line-through').html(VCPrice).show();
    }else{
       $(this).parents('.product-item').find('.cart_compatible_accessories_url .item-price .tw-line-through').hide();
    }
    if(inventory_quantity <=0 && inventory_policy =='continue'){
       $(this).parents('.product-item').find('.cart_compatible_accessories_url .compatible_accessories_preOrder').show(); 
    }else{
      $(this).parents('.product-item').find('.cart_compatible_accessories_url .compatible_accessories_preOrder').hide(); 
    }
});
/** variant select box change event END HERE**/ 
